document.addEventListener('click', (event) => {
  const button = event.target.closest('.js-video-poster-button');
  if (!button) return;

  const wrapper = button.closest('.video-poster');
  if (!wrapper) return;

  const mediaContainer = wrapper.querySelector('.video-poster__media');
  if (!mediaContainer) return;

  // Masquer le poster
  button.remove();

  // Afficher le conteneur vidéo
  mediaContainer.hidden = false;

  const iframe = mediaContainer.querySelector('iframe');
  const video = mediaContainer.querySelector('video');

  // Cas YouTube / Vimeo
  if (iframe) {
    let src = iframe.getAttribute('src') || '';
    if (!src.includes('autoplay=1')) {
      const separator = src.includes('?') ? '&' : '?';
      src += `${separator}autoplay=1&muted=1&mute=1`;
      iframe.setAttribute('src', src);
    }
  }

  // Cas vidéo Shopify hébergée
  if (video) {
    try {
      video.muted = true;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          // certains navigateurs peuvent bloquer, mais on évite d'afficher une erreur
        });
      }
    } catch (e) {
      // rien à faire côté UX
    }
  }
});
